import send from "@/utils/request";

//购物车列表
export function userCartSelect(params = {}) {
  return send({ url: '/ipp/v3/user/cart/select', method: 'POST', data: params });
}

//数量变更
export function userCartSet(params = {}) {
  return send({ url: '/ipp/v3/user/cart/set', method: 'POST', data: params });
}

//商品搜索
export function productSelect(params = {}) {
  return send({ url: '/ipp/v3/product/select', method: 'POST', data: params });
}

//加入购物车
export function userCartJoin(params = {}) {
  return send({ url: '/ipp/v3/user/cart/join', method: 'POST', data: params });
}

//购物车删除商品
export function userCartDelete(params = {}) {
  return send({ url: '/ipp/v3/user/cart/delete', method: 'POST', data: params });
}

//收藏/取消收藏
export function userCollectJoin(params = {}) {
  return send({ url: '/ipp/v3/user/collect/join', method: 'POST', data: params });
}

//清空购物车
export function userCartClear(params = {}) {
  return send({ url: '/ipp/v3/user/cart/clear', method: 'POST', data: params });
}

//订单确认初始化
export function purchaseOrderSelect(params = {}) {
  return send({ url: '/ipp/v3/purchase/order/select', method: 'POST', data: params });
}

//确认单更换地址逻辑处理
export function purchaseOrderLogic(params = {}) {
  return send({ url: '/ipp/v3/purchase/order/logic', method: 'POST', data: params });
}

//订单创建
export function purchaseOrderCreate(params = {}) {
  return send({ url: '/ipp/v3/purchase/order/create', method: 'POST', data: params });
}
